import React from 'react';
import Output from '../../../components/Output';
import TableParametrage from '../components/TableParametrage';

const TableParametrageBody = ({ offerType }) => {
  return <Output>

    <TableParametrage
      offerType={offerType}
      tableType="PRICINGS"
    />

  </Output>;
};

export default TableParametrageBody;
